export const messaging = {
  extraCare: {
    repairHeading: 'Enjoy peace of mind with JB Hi-Fi Extra Care Repair Cover.',
    replacementHeading: 'Enjoy peace of mind with JB Hi-Fi Extra Care Replacement Cover.',
  },
  mobileExtras: {
    heading: 'Get more from your phone with Mobile Extras',
    ipadHeading: 'Get more from your iPad',
  },
};
